import { NavMenu } from "../../common/navMenu.js";

export default function initQuickLinks() {
  const quickLinkEl = document.querySelector(".js-quick-links");

  if (quickLinkEl) {
    const quickLinksMenu = new NavMenu({
      animationDelay: 600,
      closed: true,
      direction: "vertical",
      menuButton: ".js-quick-links-toggle",
      menuContainer: ".js-quick-links-menu",
      menuLink: ".js-quick-links-link",
      parent: quickLinkEl,
      hover: false,
    });

    //Center Vertically on the page
    quickLinkEl.style.top = `${
      window.innerHeight / 2 - quickLinkEl.offsetHeight / 2
    }px`;
  }
}
